import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { RecordsClient } from '@/features/records/ui/records-client';
import { Spinner } from '@/shared/ui';

export function RecordsPage() {
  return (
    <>
      <Helmet>
        <title>기록서 조회 | 동구바이오제약</title>
      </Helmet>
      <Suspense
        fallback={
          <div className="w-full h-full flex items-center justify-center">
            <Spinner size="sm" />
          </div>
        }
      >
        <RecordsClient />
      </Suspense>
    </>
  );
}
